import { dataUserBookmark } from 'dls-icons-data'
import { createIcon } from '../common'

const IconUserBookmark = /*#__PURE__*/createIcon(dataUserBookmark)
export default IconUserBookmark
